import AlertsApi from "../../../api/alerts-api";
import TechnicalStatusesApi from "../../../api/technical-statuses-api";
import { AlertTypes } from "../../../constants/alert_types";
import moment from "moment-timezone";

// initial state
const initialState = () => ({
  isFetching: false,
  gateways: [],
  cowsNotSeen: [],
  cowsWithHighPM: [],
  totals: {}
});

// actions
const actions = {
  getGatewayStatuses: async ({commit}, payload) => {
    try{
      commit("request", payload);

      const apiResponse = await TechnicalStatusesApi.getGateways();

      if (apiResponse && apiResponse.data){
        commit("getGatewayStatusesSuccess", { data: apiResponse.data })
        commit("updateTotals", { gatewayStatus: apiResponse.data.length })
      }else{
        commit("getTechnicalStatusFailed")
      }

    } catch(e){
      commit("getTechnicalStatusFailed", e)
    }
  },
  manageGateways: async({commit}, payload) =>{
    try{
      commit("request", payload);

      const apiResponse = await TechnicalStatusesApi.manageGateways();
      
      if (apiResponse && apiResponse.data){
        commit("manageGatewaysSuccess", { data: apiResponse.data })
      }else{
        commit("manageGatewaysFailed")
      }

    } catch(e){
      commit("manageGatewaysFailed", e)
    }
  },
  getCowsNotSeen: async ({commit}, payload) => {
    try{
      commit("request", payload);

      const apiResponse = await TechnicalStatusesApi.getCowsNotSeen();

      if (apiResponse && apiResponse.data){
        commit("getCowsNotSeenSuccess", { data: apiResponse.data })
        commit("updateTotals", { cowsNotSeen: apiResponse.data.length })
      }else{
        commit("getTechnicalStatusFailed")
      }

    } catch(e){
      commit("getTechnicalStatusFailed", e)
    }
  },
  getCowsWithHighPM: async ({commit}, payload) => {
    try{
      commit("request", payload);

      const apiResponse = await TechnicalStatusesApi.getCowsWithHighPM();

      if (apiResponse && apiResponse.data){
        commit("getCowsWithHighPMSuccess", { data: apiResponse.data })
        commit("updateTotals", { cowsWithHighPM: apiResponse.data.length })
      }else{
        commit("getTechnicalStatusFailed")
      }

    } catch(e){
      commit("getTechnicalStatusFailed", e)
    }
  },

  clear: ({ commit }) => {
    commit("clear", initialState());
  }
};

// mutations
const mutations = {
  request: (state) => {
    state.isFetching = true;
  },
  manageGatewaysSuccess: (state, {data}) => {
    state.gateways = data;
    state.isFetching = false;
  },
  manageGatewaysFailed: (state) => {
    state.isFetching = false
  },
  getGatewayStatusesSuccess: (state, {data})=>{
    state.gateways = data;
    state.isFetching = false;
  },
  getCowsNotSeenSuccess: (state, {data})=>{
    state.cowsNotSeen = data;
    state.isFetching = false;
  },
  getCowsWithHighPMSuccess: (state, {data})=>{
    state.cowsWithHighPM = data;
    state.isFetching = false;
  },
  getTechnicalStatusFailed: (state)=>{
    state.isFetching = false;
  },
  updateTotals: (state, payload) => {
    state.totals = {...state.totals, ...payload};
  },
  clear: (state, initialState) => {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/plugins/store/modules/technical-statuses.js